import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

export interface UserInfo {
  username?: string;
  avatar?: string;
}


export class OUserInfoService {
  protected storedInfo: UserInfo;
  private subject = new Subject<any>();

  constructor(protected injector: Injector) {
  }

  setUserInfo(info: UserInfo) {
    this.storedInfo = info;
    this.subject.next(info);
  }

  getUserInfo(): UserInfo {
    return this.storedInfo;
  }

  getUserInfoObservable(): Observable<any> {
    return this.subject.asObservable();
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
